import { useQuery } from "@tanstack/react-query";
import { getAllOrgStructureAssignments } from "../../api/apiOrgStructureAssignments";
import i18next from "i18next";

export function useGetOrgStructureAssignments(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({
        queryKey: ["orgStructureAssignments", page, perPage, filters, i18next.language],
        queryFn: () => getAllOrgStructureAssignments(page, perPage, filters),
        retry: false,
    });
    const assignments = data?.data?.items || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };
    return { isLoading, error, assignments, meta };
}
